import React from 'react';
import { Typography, CardMedia, Grid } from '@material-ui/core';

const data = (
<Typography component="div">
  <h1>MIPS Simulator and Testbentch</h1>


  <h2>Objective</h2>
  <p>
    The objective for this project is to learn how to use Makefile, Bash and apply my understanding for CPU architecture.
  </p>

  <h2>Architecture Overview</h2>
  <p>
    <img src={require('./arch.svg')} width="650" /><br/>
    For details about the design and evaluation, please view the readme file from the Github link below.
  </p>


  <h2>Outcome</h2>
  <p>
    The MIPS simulator is fully correct, but the test case does not have enough coverage to find all false-negative simulators. During the assessment around 1/3 broken simulator passed the test.
  </p>
</Typography>
)
export default data